import { createReducer, on } from '@ngrx/store';

import { DevAuthModuleState } from '../../models/dev-auth.model';
import * as devAuthActions from '../actions/dev-auth-actions';

export const devAuthReducer = createReducer<DevAuthModuleState>(
  {} as DevAuthModuleState,
  on(devAuthActions.sendAuthenticatedRequestSuccess, (state, { response }) => ({
    ...state,
    devAuth: response,
  })),
);
